import { isTestEnvironment } from './config'

/**
 * Wird der Menüpunkt „Anforderungen & Anfragen" angezeigt?
 *
 * Anforderungen und Anfragen entstehen dort, wo gearbeitet wird — auf der
 * Produktion. Auf der Testumgebung stehen sie zwar auch zur Verfügung, aber
 * was dort erfasst wird, sieht niemand, der es bearbeiten müsste: Die beiden
 * Umgebungen haben getrennte Datenbestände. Ein Menüpunkt, der zu einer Liste
 * führt, in der nichts Echtes steht, ist deshalb eine Einladung zum Irrtum.
 *
 * Die Regel:
 *
 *   - Ist die Einstellung `ticketsMenu` gesetzt, gilt sie — sie ist die
 *     ausdrückliche Entscheidung der Bundesadministration.
 *   - Ist sie es nicht, entscheidet die Umgebung: auf der Produktion sichtbar,
 *     auf der Testumgebung nicht.
 *
 * Der zweite Fall ist der wichtigere. Die Testumgebung bekommt ihren
 * Datenbestand als Kopie der Produktion; eine dort gesetzte Einstellung käme
 * mit der nächsten Kopie wieder als „sichtbar" zurück. Die Umgebung als
 * Vorgabe übersteht das, und wer den Menüpunkt zum Prüfen doch braucht,
 * schaltet ihn in den Einstellungen ein.
 *
 * Der Hilfe-Knopf unten rechts bleibt in beiden Fällen — mit ihm lässt sich die
 * Anfrage-Strecke auf Test weiterhin durchspielen, und er führt nicht in eine
 * Liste, sondern in ein Formular.
 */
export const TICKETS_MENU_OPTION = 'ticketsMenu'

export const showTicketsMenu = options => {
	const wert = options?.[TICKETS_MENU_OPTION]

	// Ausdrücklich gesetzt — auch "false" ist eine Entscheidung und darf nicht
	// als "nichts gesetzt" durchgehen.
	if (typeof wert === 'boolean') return wert

	return !isTestEnvironment()
}
